import { Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import PageLayout from '../components/PageLayout';
import PageHeader from '../components/PageHeader';
import { HelpCategoryCard } from '../components/help';
import { useHelpArticles } from '../hooks/useHelpArticles';

export default function HelpIndexPage() {
  const { categories, articles } = useHelpArticles();

  // Count articles per category
  const getArticleCount = (categorySlug: string) =>
    articles.filter((a) => a.category === categorySlug).length;

  return (
    <PageLayout maxWidth="standard" title="Help Center">
      <PageHeader
        title="Help Center"
        subtitle="Learn how to get the most out of ORO move"
      />

      {/* Category grid */}
      <div className="grid gap-4 sm:grid-cols-2">
        {categories.map((category) => (
          <HelpCategoryCard
            key={category.slug}
            category={category}
            articleCount={getArticleCount(category.slug)}
          />
        ))}
      </div>

      {/* FAQ link */}
      <div
        className="mt-8 rounded-lg border p-5 text-center"
        style={{
          backgroundColor: 'var(--oro-surface-alt)',
          borderColor: 'var(--oro-border)',
        }}
      >
        <HelpCircle
          className="mx-auto h-8 w-8 mb-3"
          style={{ color: 'var(--text-muted)' }}
        />
        <h3
          className="font-medium"
          style={{ color: 'var(--text-primary)' }}
        >
          Can't find what you're looking for?
        </h3>
        <p
          className="mt-1 text-sm"
          style={{ color: 'var(--text-secondary)' }}
        >
          Check our FAQ or get in touch with us.
        </p>
        <div className="mt-4 flex justify-center gap-3">
          <Link
            to="/faq"
            className="rounded-lg px-4 py-2 text-sm font-medium transition-colors"
            style={{
              backgroundColor: 'var(--oro-surface)',
              color: 'var(--text-primary)',
              border: '1px solid var(--oro-border)',
            }}
          >
            View FAQ
          </Link>
          <Link
            to="/contact"
            className="rounded-lg px-4 py-2 text-sm font-medium transition-colors"
            style={{
              backgroundColor: 'var(--oro-gold)',
              color: 'var(--oro-bg)',
            }}
          >
            Contact Us
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}
